import { ENUM_LABELS, GENERIC_SCALAR_TYPES, enumLabel } from "./enumLabels";

// BE sends primitives raw (Boolean→"true"/"false", dates ISO) and resolves
// FK/DomainObject refs to labels already. FE only formats locale-specific
// primitives + enum tokens.

const CZ_DATE_TIME = (d) =>
  `${d.getDate()}.${d.getMonth() + 1}.${d.getFullYear()} ${String(d.getHours()).padStart(2, "0")}:${String(d.getMinutes()).padStart(2, "0")}`;
const CZ_DATE = (d) => `${d.getDate()}.${d.getMonth() + 1}.${d.getFullYear()}`;

export function formatAuditValue(value, fieldType, entityType, field) {
  if (value == null || value === "") return value;
  switch (fieldType) {
    case "Boolean":
    case "boolean":
      return value === "true" ? "Ano" : value === "false" ? "Ne" : value;
    case "Instant":
    case "LocalDateTime": {
      const d = new Date(value);
      return isNaN(d.getTime()) ? value : CZ_DATE_TIME(d);
    }
    case "LocalDate": {
      const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(value);
      return m ? `${parseInt(m[3], 10)}.${parseInt(m[2], 10)}.${m[1]}` : value;
    }
    default: {
      if (fieldType && ENUM_LABELS[fieldType]) return enumLabel(fieldType, value);
      const enumClass = GENERIC_SCALAR_TYPES[entityType] && GENERIC_SCALAR_TYPES[entityType][field];
      if (enumClass && ENUM_LABELS[enumClass]) return enumLabel(enumClass, value);
      return value;
    }
  }
}
